import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  styled,
} from "@mui/material";
import clsx from "clsx";
import { Link } from "react-router-dom";

const ItemInnerStyled = styled("div")({
  width: "32px",
  display: "flex",
  justifyContent: "center",
  "& img": {
    width: "auto",
    height: "16px",
  },
});

const LinkStyled = styled(Link)({
  textDecoration: "none",
  color: "inherit",
});

const MenuItemIcon = ({ icon, iconComponent, iconClass }) => {
  const hasIcon = Boolean(iconComponent) || Boolean(iconClass) || Boolean(icon);

  return hasIcon ? (
    <ListItemIcon>
      {Boolean(icon) && (
        <ItemInnerStyled>
          <img src={icon} alt="item-icon" />
        </ItemInnerStyled>
      )}
      {Boolean(iconComponent) && iconComponent}
      {Boolean(iconClass) && <i className={clsx("icon", iconClass)} />}
    </ListItemIcon>
  ) : null;
};

const MenuDropdownItem = ({
  href,
  icon,
  iconClass,
  iconComponent,
  label,
  target,
  isDivider,
  onClick,
}) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick?.(e);
  };

  const isLink = Boolean(href);

  if (isDivider) {
    return <Divider sx={{ margin: "4px" }} />;
  }
  return isLink ? (
    <LinkStyled to={href} target={target}>
      <MenuItem onClick={handleClick} dense>
        <MenuItemIcon
          icon={icon}
          iconComponent={iconComponent}
          iconClass={iconClass}
        />
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    </LinkStyled>
  ) : (
    <MenuItem onClick={handleClick} dense>
      <MenuItemIcon
        icon={icon}
        iconComponent={iconComponent}
        iconClass={iconClass}
      />
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};

export default MenuDropdownItem;
